/**
 * Why the campaign refused a mileage submission or a screenshot.
 *
 * Mirrors the reason codes the reports and evidence endpoints return beside a
 * refusal, so a participant can be told what happened in words rather than
 * shown the code.
 */
export enum SubmissionRejectionReason {
  RiderCountOutOfRange = "rider_count_out_of_range",
  RiderNotInHousehold = "rider_not_in_household",
  MilesOutOfRange = "miles_out_of_range",
  RideDateOutOfWindow = "ride_date_out_of_window",
  WarmUpCarryOverClosed = "warm_up_carry_over_closed",
  EvidenceNotUsable = "evidence_not_usable",
  UploadLimitReached = "upload_limit_reached",
}
